import {
  ICameraRenderScene,
  IProductRenderScene,
  IRenderSceneConfigData,
} from "../../../../services/api/3d/RenderSceneApi/type";
import { EnvironmentService } from "../../../../services/EnvironmentService";
import { ObjectService } from "../../../../services/ObjectService";
import { MOCK_ORGANIZATION_ID } from "../../../../utils/constants";
import { stateT } from "../../types";

import { getActiveEnvironmentStage } from "./enviromentSelectors";
import {
  getProductByIdAndPath,
  getSelectObjectDataById,
} from "./objectSelectors";

export const getCamera = (state: stateT) => {
  return state.ui.camera;
};

export const getDataForRenderScene =
  (body: string) =>
    (state: stateT): IRenderSceneConfigData => {
      const stage = getActiveEnvironmentStage(state);


      if (!stage) {
        throw new Error("Stage not found");
      }

      const camera = getCamera(state);

      const productsResult: IProductRenderScene[] = [];
      let cameraResult: ICameraRenderScene | null = null;

      const arrDataScene = JSON.parse(body) as any[];
      arrDataScene.forEach((item: any) => {
        if (item.id && item.id === "camera") {
          cameraResult = {
            ...camera,
            position: item.pos,
            forward: item.forward,
            up: item.up,
            fov: camera.fov,
            renderWidth: item.renderWidth || camera.renderWidth,
            renderHeight: item.renderHeight || camera.renderHeight,
            imageWidth: item.imageWidth || camera.imageWidth,
            imageHeight: item.imageHeight || camera.imageHeight,
            exposure: item.exposure || camera.exposure,
          };
        } else {
          const idProduct = item.id;
          const {
            pathObjectIds,
            geometryOptions,
            materialOptions,
            realId,
            projectId,
          } = getSelectObjectDataById(idProduct)(state);

          let product = getProductByIdAndPath(
            realId,
            pathObjectIds,
            projectId
          )(state);

          // Fallback to productsCache if not found by path
          if (!product) {
            const cache = state.ui.productsCache[projectId];
            if (cache) {
              product = cache.find(p => p.id === realId) || null;
            }
          }

          if (product) {
            const geometryOpts = ObjectService.getOptionsByProductAndSelectData(
              "geometry",
              product,
              geometryOptions
            );
            const materialOpts = ObjectService.getOptionsByProductAndSelectData(
              "material",
              product,
              materialOptions
            );

            // Clean up empty string resourceUrls to null
            const allOptions = [...geometryOpts, ...materialOpts].map(opt => ({
              ...opt,
              resourceUrl: opt.resourceUrl === "" ? null : opt.resourceUrl
            }));

            const productData = {
              position: item.pos,
              rotation: item.rot,
              forward: item.forward,
              up: item.up,
              scale: item.scale,
              id: product.id,
              name: product.name,
              projectId: product.projectId,
              paramString: product.paramString,
              resourceUrl: product.resource ?? null,
              options: allOptions,
            };

            productsResult.push(productData);
          }
        }
      });

      if (!cameraResult) {
        throw new Error("Camera data not found in the scene data");
      }

      // const stageParam = {
      //   id: stage.id,
      //   name: stage.name,
      //   paramString: stage.paramString,
      //   resourceUrl: stage?.resource,
      // };

      return {
        organizationId: MOCK_ORGANIZATION_ID,
        config: {
          stage: EnvironmentService.getFormattedEnvironmentData(stage),
          camera: cameraResult,
          products: productsResult,
        },
      };
    };
